import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CreateEntityForm } from './create-entity-form';
import { UpdateEntity } from './update-entity';

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    CreateEntityForm,
    UpdateEntity,
  ],
})
export class AssessmentUtilitiesModule { }
